import { blockType } from "../constants";
import { ZapbotBlockSchema } from "../schema";
import { strings } from "../strings";
import type { Zapbot } from "../types";

export const create: Zapbot["create"] = () => {
  return ZapbotBlockSchema.parse({
    type: blockType,
    config: {
      testBotButtonCopy: strings.ZAPBOT_PROMPT_BLOCK_BUTTON_DEFAULT_COPY,
      style: {
        width: "narrow",
        alignment: "center",
      },
    },
  });
};
